import React, { useEffect, useState } from "react";
import { LocalizationProvider , DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { getData } from "../../utils/GlobalHelper";
import thLocale from "date-fns/locale/th";
import enLocale from "date-fns/locale/en-US";
import { format, parseISO } from "date-fns";

const localeMap = {
    th: thLocale,
    en: enLocale,
};

const DesktopDatePickerComponent = ({
    id,
    label,
    value,
    minDate,
    maxDate,
    openTo,
    views,
    formatDate = "dd/MM/yyyy",
    onChange,
    required,
}) => {
    const lang = getData("lang");
const [initialValue, setInitialValue] = useState(null);

    const handleOnChange = (changeDate) => {
        setInitialValue(changeDate);
        if (onChange) {
            onChange(new Date(changeDate));
        }
    }

    
    useEffect(() => {
        if (value) {
            setInitialValue(value);
        }
    }, [value])

    return (
        <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={localeMap[lang]}
        >
            <DesktopDatePicker
                value={initialValue}
                format={formatDate}
                minDate={minDate}
                maxDate={maxDate}
                openTo={openTo}
                views={views}
                onChange={handleOnChange}
                slotProps={
                    {
                        textField: {
                            label: label,
                            id: id,
                            variant: "standard",
                            required: required
                        }
                    }
                }
            />
        </LocalizationProvider>
    );
}

export default DesktopDatePickerComponent;